import mapboxgl from 'mapbox-gl';

const MapboxGL = mapboxgl.supported() ? mapboxgl : null;

if (MapboxGL) {
    MapboxGL.accessToken = MA.Config.MAPBOX_ACCESS_TOKEN;
}

export default MapboxGL;
